import { ChartWrapper } from './ChartWrapper';
import { ChartContent } from './ChartContent';
import { ChartLegend } from './ChartLegend';

export const Chart = {
    Wrapper: ChartWrapper,
    Content: ChartContent,
    Legend: ChartLegend,
};
